import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  ViewChild
} from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    selector: 'app-catalogue-search',
    templateUrl: './catalogue-search.component.html',
    styleUrls: ['./catalogue-search.component.scss'],
    standalone: false
})
export class CatalogueSearchComponent {
  searchText: string;

  @ViewChild('search') searchField: ElementRef;
  @ViewChild('searchMenu') searchMenu: ElementRef;
  @ViewChild('clear') clear: ElementRef;

  @Output() triggerSearch = new EventEmitter<string>();

  @HostListener('document:click', ['$event']) clickOut(event) {
    if (!this.searchField.nativeElement.contains(event.target) &&
      !this.searchMenu?.nativeElement.contains(event.target)) {
    }
  }

  onSearch(event) {
    this.searchText = event;
    this.triggerSearch.emit(this.searchText);
  }

  showSearchOptions(event) {
    event.stopPropagation();
    this.focusOnInput();
  }

  onCloseClick(event) {
    this.clearInputField(event);
    this.removeFocus();
  }

  clearInputField(event) {
    event.stopPropagation();
    this.searchField.nativeElement.value = null;
    this.searchText = null;
    this.triggerSearch.emit(this.searchText);
    this.focusOnInput();
  }

  private focusOnInput() {
    this.searchField.nativeElement.focus();
  }

  private removeFocus() {
    this.searchField.nativeElement.blur();
  }
}
